import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import MaterialWarehouseService from "../../../../../API/orders/warehouse/material/MaterialWarehouseService";
import FilterUtil from "../../../../../utils/common/FilterUtil";
import ModalUpdateCutOff from "./ModalUpdateCutOff";
import DateTimeUtil from "../../../../../utils/common/DateTimeUtil";
import CellCheckboxWithUnableWithComment from "./CellCheckboxWithUnableWithComment";
import ErrorModal from "../../../modal/ErrorModal";
import MenuItem from "@mui/material/MenuItem";
import {useIsAccessGranted} from "../../../../../utils/useIsAccessGranted";

const MaterialWarehouseCutOffsTable = ({
                                           isPlace,
                                           data,
                                           setData,
                                           unableCut,
                                           setUnableCut,
                                           handleModalAlert
                                       }) => {

        const isAllowedEdit = useIsAccessGranted(["ROLE_ORGANIZATION_USER_CUT", "ROLE_ORGANIZATION_USER_OPTIMIZATION"])
        const [newValue, setNewValue] = useState(null);
        const [unableCheckbox, setUnableCheckbox] = useState(false);
        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [currentEditRow, setCurrentEditRow] = useState(null);
        const [createOrUpdateModalOpen, setCreateOrUpdateModalOpen] = useState(false);
        const [modalErrorOpen, setModalErrorOpen] = useState(false);
        const [materialPriceUnit, setMaterialPriceUnit] = useState(null);

        const columns = useMemo(() => {
            const baseColumns = [
                {
                    id: 'length',
                    header: 'W',
                    accessorKey: 'materialPriceUnit.length',
                    minSize: 10,
                    maxSize: 10,
                },
                {
                    id: 'width',
                    header: 'H',
                    accessorKey: 'materialPriceUnit.width',
                    minSize: 10,
                    maxSize: 10,
                },

                {
                    id: 'confirmedAfterCutting',
                    header: 'Подт.',
                    accessorKey: 'confirmedAfterCutting',
                    size: 8,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <CellCheckboxWithUnableWithComment
                        unable={unableCut}
                        setUnable={handleUnableCheckbox}
                        setModalOpen={setCreateOrUpdateModalOpen}
                        setUnableCheckbox={setUnableCheckbox}
                        setNewValue={setNewValue}
                        setCurrentEditRowData={setCurrentEditRowData}
                        setCurrentEditRow={setCurrentEditRow}
                        row={row}
                    >
                    </CellCheckboxWithUnableWithComment>,
                },
                {
                    id: 'note',
                    header: 'Ком.',
                    accessorKey: 'note',
                    size: 180,
                    Cell: ({cell}) => {
                        {
                            return cell.getValue() === null ? "" : cell.getValue();
                        }
                    },
                },
                {
                    header: 'id',
                    id: 'id',
                    accessorKey: 'id',
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                    enableHiding: false,
                },
            ];

            if (isPlace) {
                baseColumns.splice(13, 0, {
                    id: 'place',
                    header: 'Место',
                    accessorKey: 'warehouse.name',
                    size: 8,
                    maxSize: 8,
                    enableEditing: false,
                });
            }
            return baseColumns;

        }, [data, setData]);

        const handleUpdateModel = useCallback(
            (row) => {
                setCurrentEditRowData(row);
                setCurrentEditRow(row);
                setMaterialPriceUnit(row.materialPriceUnit);
                setCreateOrUpdateModalOpen(true);
            },
            [data, currentEditRowData, setCurrentEditRowData],
        );

        const handleCloseCreateOrUpdateModalOpen = () => {
            setCreateOrUpdateModalOpen(false)
            setCurrentEditRowData(null);
            setMaterialPriceUnit(null);
            setCurrentEditRow(null);
            setUnableCheckbox(false);

        };

        const handleSubmit = async () => {

            const note = currentEditRowData.note;
            const id = currentEditRowData.id;
            const materialWarehouse = {
                id: id,
                materialPriceUnit: materialPriceUnit,
                note: note
            };

            if (unableCheckbox && !newValue) {
                if (note != null && note.length > 4) {
                    handleUnableCheckbox(id, newValue, materialWarehouse);
                } else {
                    setModalErrorOpen(true);
                    await DateTimeUtil.timeout(2000);
                    setModalErrorOpen(false);
                }
            } else {
                updateCutOff(materialWarehouse);
            }
        }


        const updateCutOff = (materialWarehouse) => {
            MaterialWarehouseService.updateCutOff(materialWarehouse
            ).then(function (response) {
                setData(prev => prev.map(el => el.id === materialWarehouse.id ? {
                    ...el,
                    note: response.data.note,
                    materialPriceUnit: {
                        ...el.materialPriceUnit,
                        length: response.data.materialPriceUnit.length,
                        width: response.data.materialPriceUnit.width
                    }
                } : el));
                handleCloseCreateOrUpdateModalOpen();
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const handleUnableCheckbox = (id, status, materialWarehouse) => {
            MaterialWarehouseService.confirmedOrNotConfirmedCutOff(id, status, materialWarehouse?.note || "").then(function () {
                handleUnableCut(id, status)
                setData(prev => prev.map(el => el.id === id ? {...el, note: materialWarehouse?.note || ""} : el));
                handleCloseCreateOrUpdateModalOpen();
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        };

        const handleUnableCut = (id, status) => {
            unableCut[id] = status
            setUnableCut(prevState => ({
                ...prevState,
                [id]: status
            }));
        };
        const menuItem = [
            {type: "edit", text: "Редактировать", handler: handleUpdateModel},
        ]

        return (
            <div>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableBodyCellProps={({cell, table}) => {
                        return ({
                            sx: () => ({
                                p: cell.column.id === "confirmedAfterCutting" ? 0 : '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",
                                "&:after": {
                                    display: "none",
                                },
                                "& td:after": {
                                    "&:hover": {
                                        backgroundColor: "red"
                                    }
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',
                                },

                                "&:first-of-type": isAllowedEdit && {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                            })
                        })
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                "minWidth": "100%"
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                    }}
                    state={{showGlobalFilter: true}}
                    columns={columns}
                    data={data}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 50},
                    }}
                    enableRowActions={isAllowedEdit}
                    enableToolbarInternalActions={false}
                    getRowId={(originalRow) => originalRow.id}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        return <MenuItem
                            key={el.type}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    localization={MRT_Localization_RU}
                />
                <ModalUpdateCutOff
                    values={currentEditRowData}
                    setValues={setCurrentEditRowData}
                    open={createOrUpdateModalOpen}
                    materialPriceUnit={materialPriceUnit}
                    setMaterialPriceUnit={setMaterialPriceUnit}
                    handleClose={() => handleCloseCreateOrUpdateModalOpen()}
                    handleSubmit={handleSubmit}
                    unableCheckbox={unableCheckbox}
                />
                <ErrorModal
                    setOpen={setModalErrorOpen}
                    open={modalErrorOpen}
                    message={'Комментарий не заполнен, либо количество символов менее 5'}
                />
            </div>
        );
    }
;

export default MaterialWarehouseCutOffsTable;